export default __webpack_public_path__ + "static/media/nexum-capitals-logo.33e8c941.png";